// extracted by mini-css-extract-plugin
module.exports = {"container":"Steps_container__1Lu7o","item":"Steps_item__2UWWx","title":"Steps_title__1AnpC","description":"Steps_description__2uF4r","image":"Steps_image__1Kyp7"};